var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 15.9998C16.7334 15.9998 17.3614 15.7385 17.884 15.2158C18.4067 14.6932 18.6676 14.0656 18.6667 13.3332C18.6667 12.5998 18.4054 11.9718 17.8827 11.4492C17.36 10.9265 16.7325 10.6656 16 10.6665C15.2667 10.6665 14.6387 10.9278 14.116 11.4505C13.5934 11.9732 13.3325 12.6007 13.3334 13.3332C13.3334 14.0665 13.5947 14.6945 14.1174 15.2172C14.64 15.7398 15.2676 16.0007 16 15.9998ZM16 25.7998C18.7112 23.3109 20.7223 21.0496 22.0334 19.0158C23.3445 16.9821 24 15.1767 24 13.5998C24 11.1776 23.2276 9.1945 21.6827 7.6505C20.1378 6.1065 18.2436 5.33406 16 5.33317C13.7556 5.33317 11.8609 6.10561 10.316 7.6505C8.77115 9.19539 7.99915 11.1785 8.00004 13.5998C8.00004 15.1776 8.6556 16.9834 9.96671 19.0172C11.2778 21.0509 13.2889 23.3118 16 25.7998ZM16 29.3332C12.4223 26.2887 9.75026 23.4612 7.98404 20.8505C6.21782 18.2398 5.33426 15.8229 5.33337 13.5998C5.33337 10.2665 6.40582 7.61095 8.55071 5.63317C10.6956 3.65539 13.1787 2.6665 16 2.6665C18.8223 2.6665 21.3058 3.65539 23.4507 5.63317C25.5956 7.61095 26.6676 10.2665 26.6667 13.5998C26.6667 15.8221 25.7832 18.2389 24.016 20.8505C22.2489 23.4621 19.5769 26.2896 16 29.3332Z",
    fill: "#E95A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.80ee9bfaa9a01c8c71ca45a960a21eba.svg";
export { ForwardRef as ReactComponent };